import { EventAnimationLine } from 'Components/lines/event-animation-line/EventAnimationLine';
export default EventAnimationLine;
